module.exports = __webpack_public_path__ + "img/Dantam Makeover 08.69ee0808.jpg";